/**
 * Custom Product Layout — moves the collapsible/accordion section
 * from below the main product into the right sticky info panel
 * (NudeProject style)
 */
(function () {
  'use strict';

  function moveAccordionsIntoRightPanel() {
    // Only on product pages, only on desktop
    if (window.innerWidth < 990) return;

    var infoWrapper = document.querySelector('.product__info-wrapper');
    if (!infoWrapper) return;

    // Already moved? bail
    if (infoWrapper.querySelector('.moved-collapsible-section')) return;

    // Find the collapsible content section (rendered AFTER main-product)
    // Common selectors used by Shopify themes for collapsible content sections
    var candidates = [
      '.shopify-section[id*="collapsible"]',
      '.shopify-section[id*="reductible"]',
      '.shopify-section .collapsible-content',
      '.shopify-section .collapsible_content',
      'section.collapsible-content',
      '.collapsible-content-wrapper'
    ];

    var collapsibleSection = null;
    for (var i = 0; i < candidates.length; i++) {
      var el = document.querySelector(candidates[i]);
      if (el) {
        // Walk up to the wrapping shopify-section if needed
        collapsibleSection = el.closest('.shopify-section') || el;
        break;
      }
    }

    if (!collapsibleSection) return;

    // Wrap and inject into the right panel
    var wrapper = document.createElement('div');
    wrapper.className = 'moved-collapsible-section';
    wrapper.appendChild(collapsibleSection);
    infoWrapper.appendChild(wrapper);
  }

  function init() {
    // Run on initial load
    moveAccordionsIntoRightPanel();

    // Re-run if Shopify section is re-rendered in editor
    document.addEventListener('shopify:section:load', moveAccordionsIntoRightPanel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
